import * as NameSpace from '../NameSpace'
import { merge } from '../../Services/objectModifier'

const state = {
  [NameSpace.MODAL_CONFIG]: {
    header: 'Alert',
    message: 'An action is required!',
    buttons: {
      accept: {
        text: 'OKAY',
        action: null
      },
      decline: {
        text: 'DECLINE',
        present: false,
        action: null
      }
    },
    type: null
  },
  [NameSpace.MODAL_RESPONSE]: {
    response: null
  },
  [NameSpace.MODAL_CONFIG_DEFAULT]: {
    header: 'Alert',
    message: 'An action is required!',
    buttons: {
      accept: {
        text: 'OKAY'
      },
      decline: {
        text: 'DECLINE',
        present: false
      }
    },
    type: null
  }
}

const getters = {
  [NameSpace.MODAL_CONFIG_GETTER]: state => {
    return state[NameSpace.MODAL_CONFIG]
  },
  [NameSpace.MODAL_RESPONSE_GETTER]: state => {
    return state[NameSpace.MODAL_RESPONSE]
  }
}

const mutations = {
  [NameSpace.MODAL_CONFIG_MUTATE]: (state, payload) => {
    state[NameSpace.MODAL_CONFIG] = merge(state[NameSpace.MODAL_CONFIG_DEFAULT], payload)
  },
  [NameSpace.MODAL_RESPONSE_MUTATE]: (state, payload) => {
    state[NameSpace.MODAL_RESPONSE] = payload
  }
}

const actions = {
  [NameSpace.SET_MODAL_CONFIG_ACTION]: ({ commit }, payload) => {
    commit(NameSpace.MODAL_CONFIG_MUTATE, payload)
  },
  [NameSpace.SET_MODAL_RESPONSE_ACTION]: ({ commit }, payload) => {
    commit(NameSpace.MODAL_RESPONSE_MUTATE, payload)
    setTimeout(() => {
      commit(NameSpace.MODAL_RESPONSE_MUTATE, null)
    }, 100)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/modalConfig.js